import isNil from "lodash/isNil";
import { useQuery } from "urql";

import { GetClikContactsDocument } from "../../../graphql/generated.ts";

interface Props {
  clikResultId: number | null | undefined;
}

export function useClikContacts({ clikResultId }: Props) {
  return useQuery({
    query: GetClikContactsDocument,
    variables: { clikResultId: Number(clikResultId) },
    pause: isNil(clikResultId),
  });
}
